// extracted by mini-css-extract-plugin
export default {"swimSpaGridItem":"SwimSpaGridItem_swimSpaGridItem__3FbJo","title":"SwimSpaGridItem_title__s-fXg","brand":"SwimSpaGridItem_brand__xQzhq"};